/**
 * Model for a single entry in the quicknav table of contents.
 */
export class QuickNavTocEntry {
  /**
   * TOC entry label (displayed to the user).
   */
  label: string;

  /**
   * Fragment identifier. This should correspond to a valid element ID on the current page.
   */
  fragment: string;

  /**
   * Property that determines whether to show the TOC entry. This may be a boolean, or a function that returns a
   * boolean.
   */
  visible: boolean|(() => boolean) = true;
}


/**
 * Container model for quicknav table of contents.
 */
export class QuickNavToc {
  /**
   * ID of the snScrollSpy directive.
   */
  scrollSpyId: string;

  /**
   * TOC entries.
   */
  entries: Array<QuickNavTocEntry>;

  constructor(id: string, entries: Array<QuickNavTocEntry>) {
    this.scrollSpyId = id;
    this.entries = entries;
  }

  /**
   * Returns only the TOC entries that are visible
   * @returns {Array<QuickNavTocEntry>}
   */
  get visibleEntries(): Array<QuickNavTocEntry> {
    return this.entries.filter(e => {
      if (typeof e.visible === 'function') {
        return e.visible();
      }
      return e.visible;
    });
  }
}
